<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
;
import InputLabelled from '../labelled.svelte';
export let name = '';
export let value = '';
export let errorMessage = undefined;
export let activeSession = undefined;
export let focus = false;
export let fluid = false;
export let loading = false;
export let placeholder = undefined;
const isValid = (value) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (value) {
            loading = true;
            yield validateExistence(value);
            loading = false;
        }
        else {
            errorMessage = undefined;
            return false;
        }
    }
    catch (errorObject) {
        errorMessage = errorObject.message;
        return false;
    }
    errorMessage = undefined;
    return true;
});
function validateExistence(value) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!activeSession) {
            return;
        }
        return activeSession.client.v1.chain.get_account(value).catch((error) => {
            const isUnkownAccountError = error.toString().includes('exception: unknown key');
            if (loading) {
                loading = false;
            }
            if (isUnkownAccountError) {
                throw {
                    valid: false,
                    message: 'Account name not found.',
                };
            }
        });
    });
}
</script>

<style type="scss"></style>

<InputLabelled {name} {fluid} {focus} {placeholder} {errorMessage} bind:value {isValid} />
